import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const sellScreenPaymentStyle = StyleSheet.create({
    balanceHistoryView: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10
    },
    paymentOuterContainer: {
        backgroundColor: appColors?.light,
        borderRadius: 5,
        gap: 10
    },
    balanceHistoryHeaderView: {
        textAlign: "center",
        backgroundColor: appColors?.buttonColor,
        padding: 10,
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5

    },
    balanceHistoryContentView: {
        textAlign: "center",
        backgroundColor: "#f8f8f8",
        padding: 10,
        borderWidth: 0.3,
        // borderBottomWidth: 0.3,
        // borderRightWidth: 0.3,
        // borderLeftWidth: 0.3,
        borderColor: appColors?.grey,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5
    },
    paymentSecondContainer: {
        flexDirection: "row",
        alignItems: "center",
    },
    amountView: {
        width: "70%",
        marginLeft: -5
    },
    labelStyle: {
        color: appColors?.primary,
        top: 15,
        left: 10,
        backgroundColor: appColors?.light,
        alignSelf: "flex-start",
        zIndex: 10,
        paddingHorizontal: 10,
        fontSize: fontSize?.smallerFontSize,
        fontFamily: appFonts?.bold
    },
    inputStyle: {
        fontSize: fontSize?.mediumFontSize,
        fontFamily: appFonts?.bold
    },
    paymentOptionView: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "space-evenly"
    },
    paymentOptionInnerView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        margin: 10,
        padding: 10,
        borderRadius: 5
    }
})